import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Typography,
  Box,
  Container,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/theme";

const faqs = [
    {
      que: "How quickly will I see results?",
      ans: " Most customers see immediate cost reductions within 24 hours of setup. Significant optimizations typically show results within the first week, with full optimization benefits realized within 30 days.",
    },
    {
      que: "What level of access do you need to my cloud environment?",
      ans: "We require read-only access to your cloud environment to analyze your infrastructure and identify savings opportunities. We do not require any write permissions, so your environment remains secure.",
    },
    {
      que: "How does your pricing model work?",
      ans: "We offer a flexible pricing model based on a percentage of the savings we generate for you. This means you only pay for the value we deliver, and our success is tied to yours.",
    },
    {
      que: "What cloud providers do you support?",
      ans: "We currently support AWS, with plans to expand to Azure and Google Cloud in the near future.",
    },
    {
      que: "How do you ensure the stability of my applications?",
      ans: "Our platform is designed to be non-intrusive and risk-averse. We use a combination of predictive analytics and real-time monitoring to ensure that our optimizations do not impact the performance or stability of your applications.",
    },
  ];

const FaqItem = ({ que, ans, expanded, onChange }) => (
  <Accordion
    disableGutters
    square
    expanded={expanded}
    onChange={onChange}
    sx={{
      mb: 2,
      borderRadius: 2,
      border: "1px solid #eee",
      boxShadow: "none",
      "&:before": {
        display: "none",
      },
    }}
  >
    <AccordionSummary expandIcon={<AddIcon />}>
      <Typography sx={{fontSize:"1.1em" , fontStyle:"normal", fontWeight:500}}>{que}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant='body2' color="text.secondary">{ans}</Typography>
    </AccordionDetails>
  </Accordion>
);

export default function FAQ() {
  const [expandedPanel, setExpandedPanel] = useState(false);

  const handleChange = (panelId) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panelId : false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ py: 8, bgcolor: "background.paper", 
        // height:{lg:"0px",md:"650px", xs:"1000px"} 
        }}>
        <Container maxWidth="lg">
          <Grid container spacing={5}>
              <Typography variant="h4" sx={{ mb: 2, color: "primary.main" }}>
                Frequently Asked Questions
              </Typography>
            <Grid item xs={12} md={8} maxWidth={{lg:'60%' ,md:"60%", sm:"55%",xs:'90%'}}>
              {faqs.map((faq, index) => (
                <FaqItem
                  key={index}
                  que={faq.que}
                  ans={faq.ans}
                  expanded={expandedPanel === `panel-${index}`}
                  onChange={handleChange(`panel-${index}`)}
                />
              ))}
            </Grid>
            <Grid item xs={12} md={4} maxWidth={{lg:'35%' , md:'55%', xs:'90%'}}>
              <Paper sx={{ px: 3,py:6, textAlign: "center", borderRadius: 2, boxShadow: 3  , ml:5}}>
                <ChatBubbleIcon sx={{ fontSize: 60, color: "primary.main", mb: 2 }} />
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  Do you have more questions?
                </Typography>
                <Typography color="text.secondary"  variant='body2' sx={{ mb: 3 }}>
                  Everything you need to know about Awsmo.
                </Typography>
                <Button href="/get-started" variant="contained" size="large">
                  Connect with us
                </Button>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

